import { render } from "./GroupView.vue?vue&type=template&id=78138af2"
import script from "./GroupView.vue?vue&type=script&lang=js"
export * from "./GroupView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__